'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _colorValidityChecks = require('./colorValidityChecks');

var _colorConverters = require('./colorConverters');

exports.default = function (color) {
  if (!(0, _colorValidityChecks.isValidColor)(color)) {
    throw new Error('Color is not a string or a valid color object');
  }

  return [_colorConverters.convertShortHexToLongHex, _colorConverters.convertLongHexToRgba, _colorConverters.convertRgbStringToRgba, _colorConverters.convertRgbaToHsl, _colorConverters.convertHslStringToHsla].reduce(function (convertedColorValue, converter) {
    return converter(convertedColorValue);
  }, color);
};